export default __webpack_public_path__ + "static/media/record_stop.5d4f6299.svg";